<template>
  <div class="like-btn">
    <button type="button" class="watchlist-btn" @click="toggleWatchlistState">
      <img :src="ico" alt="watchlist" />
      <p
        v-if="!showLoader"
        class="like-tag"
        :style="{
          color: ico !== like ? '#5568F1' : labelColor
        }"
      >
        {{ likeCount }}
      </p>
      <Loader v-else />
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase/app";
import "firebase/database";
import Content from "@/mixins/Content";
import Utility from "@/mixins/Utility";
import { EventBus } from "@/main";

export default {
  name: "LikeButton",
  props: ["content", "color", "container"],
  data() {
    return {
      action: null,
      ico: require("@/assets/icons/like_white.png"),
      like: require("@/assets/icons/like_white.png"),
      liked: require("@/assets/icons/like_blue.png"),
      likeLabel: "Like",
      labelColor: "#F2F2F2",
      previousState: null,
      currentState: null,
      likeCount: 0,
      updated: true,
      showLoader: true
    };
  },
  components: {
    Loader: () => import("@/components/Templates/loader.vue")
  },
  computed: {
    ...mapGetters(["vendorid", "subscriberid"])
  },
  watch: {
    content() {
      this.fetchButtonState();
      this.listenToLikeDislikeCountChange();
      this.likeDislikeCountWatch();
    },
    subscriberid() {
      if (this.subscriberid) {
        this.fetchButtonState();
        this.listenToLikeDislikeCountChange();
      }
    }
  },
  created() {
    this.listenToLikeDislikeCountChange();
    this.fetchButtonState();
    this.likeDislikeCountWatch();
    EventBus.$on(`${this.content.contentid}-likeDislikeStatus`, data => {
      this.updated = data;
    });
  },
  mounted() {
    if (this.color === "BLACK") {
      this.like = require("@/assets/icons/like_black.svg");
      this.labelColor = "#000000";
    }
    this.ico = this.like;
    this.content.poster = this.getPoster(this.content, "PORTRAIT");
  },
  methods: {
    likeDislikeCountWatch() {
      EventBus.$on(`${this.content.contentid}-likeDislikeCount`, data => {
        if (data) {
          if (data.like > 0) {
            this.likeCount = Number(this.likeCount) + 1;
          } else if (data.like < 0) {
            this.likeCount = Number(this.likeCount) - 1;
          }
        }
      });
    },
    listenToLikeDislikeCountChange() {
      let path = `${this.vendorid}/content/${this.content.contentid}/like`;

      firebase
        .database()
        .ref(path)
        .on("value", snapshot => {
          let response = snapshot.val();
          this.showLoader = false;

          EventBus.$emit(`${this.content.contentid}-likeDislikeStatus`, true);

          if (response && typeof response.count == "number") {
            this.showLoader = false;
            this.likeCount = this.nFormatter(Math.abs(response.count), 1);
          } else {
            this.likeCount = 0;
          }
        });
    },
    fetchButtonState() {
      if (!this.content) return;

      this.showLoader = false;
      let content = this.content;
      let contentid = content.contentid;
      let path = `${this.vendorid}/subscriber/${this.subscriberid}/content/${contentid}`;

      firebase
        .database()
        .ref(path)
        .on("value", snapshot => {
          // this.updated = true;
          let response = snapshot.val();

          // if (this.color === 'BLACK') {
          //   this.like = require('@/assets/icons/like_black.svg')
          //   this.labelColor = '#000000'
          // }
          if (response && response.likedislike === "LIKE") {
            this.action = "REMOVE";
            // this.ico = null;
            setTimeout(() => {
              this.ico = this.liked;
            }, 100);
            this.likeLabel = "Liked";
            this.previousState = this.currentState = "LIKE";
          } else {
            if (response && response.likedislike === "DISLIKE") {
              this.previousState = this.currentState = "DISLIKE";
            } else {
              this.previousState = this.currentState = "NONE";
            }
            this.action = "ADD";
            this.ico = this.like;
            this.likeLabel = "Like";
          }
        });
    },
    toggleWatchlistState() {
      if (!this.updated) return;
      this.currentState =
        this.previousState === "LIKE"
          ? "DISLIKE"
          : this.previousState === "DISLIKE"
          ? "DISLIKE"
          : "NONE";

      if (this.subscriberid) {
        this.showLoader = true;
        // console.log("Like clicked");
        this.updated = false;

        EventBus.$emit(`${this.content.contentid}-likeDislikeStatus`, false);
        this.likeLabel = this.ico === this.like ? "Liked" : "Like";
        this.ico = this.ico === this.like ? this.liked : this.like;

        // if (this.currentState === 'LIKE') {
        //   this.vLiveSDKContentLikeDislike(this.content, 1, this.previousState === 'DISLIKE' ? -1 : 0)
        // } else if (this.currentState === 'DISLIKE') {
        //   this.vLiveSDKContentLikeDislike(this.content, this.previousState === 'LIKE' ? -1 : 0, 1)
        // } else if (this.currentState === 'NONE') {
        //   this.vLiveSDKContentLikeDislike(this.content, this.previousState === 'LIKE' ? -1 : 0, this.previousState === 'DISLIKE' ? -1 : 0)
        // }

        if (this.action === "ADD") {
          this.updateLikeDislikeToFire(this.content, "LIKE");
        } else if (this.action === "REMOVE") {
          this.updateLikeDislikeToFire(this.content, "NONE");
        }
      } else {
        let data = {
          action: "LIKE",
          content: this.content
        };
        if (this.container == "Detail") {
          data.button = "LIKEDISLIKE";
        }
        if (this.container == "Share") {
          data.popup = "sharedPopup";
        }

        EventBus.$emit("LoginPopup", data);
      }
    }
  },
  mixins: [Content, Utility]
};
</script>

<style lang="scss">
.like-btn {
  background: transparent;
  border: none;
  // float: left;
  // margin-right: 30px;
  img {
    width: 30px;
  }
}
.like-tag {
  font-family: "ProximanovaRegular";
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
}
// 4k
@media screen and (min-width: 1900px) {
  .like-btn {
    img {
      width: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/likeBtn.vue